














































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IBrandGateway } from "@/models/gateways";
import { GatewayContext, GatewayStoreType } from "@/data/enums/gateway";
import { BrandConfigKeys } from "@/data/constants";

@Component
export default class GatewayComponent extends Vue {
  // Props

  @Prop({ required: true })
  public brandGateway!: IBrandGateway;

  @Prop({ required: true })
  public gatewayContext!: GatewayContext;

  @Prop({ default: true })
  public isRenderless!: boolean;

  // Data

  public form: any = {};
  public gatewayData = null;

  public created() {
    if (this.canStoreOnPayment) {
      this.$set(this.form, "store_on_payment", true);
      this.$set(this.form, "store_on_payment_auto_payment", true);
    }
  }

  /**
   * @name isEmpty
   * @desc Returns true if there's no content to render
   */

  public get isEmpty(): boolean {
    if (this.isAddContext && !this.canBeStored) return false;
    return !this.$slots["instructions"] && this.isRenderless;
  }

  /**
   * @name isAddContext
   * @desc Returns true if in the context of adding an adhoc payment method
   */

  public get isAddContext(): boolean {
    return this.gatewayContext === GatewayContext.ADD;
  }

  /**
   * @name isExternal
   * @desc Returns true if payment is processed off-site via a redirect flow
   */

  public get isExternal(): boolean {
    return !!this.brandGateway.gateway?.gateway_provider?.external_payment;
  }

  /**
   * @name canStoreOnPayment
   * @desc Returns true if payment details can be stored during the payment request
   */

  public get canStoreOnPayment(): boolean {
    if (this.isAddContext) return false;
    if (this.$store.getters.isGuestContext) return false;
    return !!this.brandGateway.gateway?.gateway_provider?.store_on_payment;
  }

  /**
   * @name canBeStored
   * @desc Returns true if gateway supports storing of payment details in the
   * current context
   */

  public get canBeStored() {
    const {
      store_type,
      store_on_payment
    } = this.brandGateway.gateway?.gateway_provider;
    if (store_type === GatewayStoreType.NONE) return false;
    if (this.isAddContext && !!store_on_payment) return false;
    return true;
  }

  /**
   * @name forceCardStorage
   * @desc Returns true if detail storage is enforced by the brand
   */

  public get forceCardStorage(): boolean {
    return (
      this.$store.getters["brand/config"][
        BrandConfigKeys.BILLING_GATEWAY_FORCE_CARD_STORAGE
      ] ?? false
    );
  }

  /**
   * @name computedData
   * @desc Returns gateway data merged with any global/common properties
   */

  public get computedData() {
    if (this.gatewayData === null) return null;
    if (this.isAddContext && !this.canBeStored) return null;
    return this.$_.merge({}, this.gatewayData, { data: this.form });
  }

  /**
   * @name relayGatewayData
   * @desc A wrapper function to relay gateway data via scoped slots
   */

  public relayGatewayData(data) {
    this.gatewayData = data;
  }

  @Watch("computedData", { deep: true, immediate: true })
  public onComputedDataChange() {
    this.$emit("input", this.computedData);
  }
}
